{
  "header": "アセットの詳細",
  "subtitle": "トラックに連結されているアセット（トレーラー、コンテナなど）。",
  "assetType": "アセットの種類",
  "assetTypePlaceholder": "アセットの種類を選択",
  "assetId": "アセット ID（例：トレーラー番号）",
  "assetIdPlaceholder": "例：トレーラー番号、コンテナ ID など",
  "remove": "削除",
  "addAnother": "アセットを追加",
  "trailerType": "トレーラーの種類",
  "trailerId": "トレーラー ID"
}
